<template>
  <div>
    <script
      type="application/javascript"
      defer
      src="https://player.twitch.tv/js/embed/v1.js"
      ref="twitchScript"
    ></script>

    <!-- Lgame NavBar -->
    <div>
      <LgameNavBar></LgameNavBar>
    </div>

    <div class="main-page-wrapper">
      <div
        class="main-page-landing-area d-flex flex-column justify-content-center position-relative pt-3 pt-lg-4 w-100 h-100 pt-lg-5"
      >
        <div
          class="landing-content d-flex flex-column justify-content-center align-items-center align-items-md-start w-100 container px-0"
        >
          <div class="row m-0 p-0">
            <div class="col col-12 col-lg-6 m-0 p-0">
              <div
                class="logos-container d-flex justify-content-center justify-content-lg-start align-items-center px-2 px-lg-4 w-100 mb-4"
              >
                <div class="logo-container tournament-logo">
                  <div class="my-2 py-4">
                    <img :src="require('@/assets/logo_.png')" height="160px" />
                  </div>
                  <h1
                    class="text-center tournament-title font-weight-bold m-0 text-uppercase"
                  >
                    Wigame Origins<br />by MSE
                  </h1>
                </div>
              </div>
              <div class="p-2">
                <p
                  class="text-white m-0 text-center text-md-left text-sub-desc"
                >
                  Prépare-toi à l’affrontement ultime ! Que ce soit sur Valorant
                  ou EA FC 26, seuls les plus talentueux atteindront la victoire
                  et marqueront l’histoire.
                </p>
              </div>
              <div class="card-participate w-100">
                <ParticipateCard :outlined="true"> </ParticipateCard>
              </div>
            </div>
          </div>
        </div>
        <div
          class="logo-mse-container position-absolute"
          style="bottom: 20px; left: 20px; z-index: 5"
        >
          <img
            :src="require('@/assets/logos/mse-logo.png')"
            height="32"
            alt="MSE logo"
          />
        </div>
      </div>
      <!-- About Tournament Section start -->
      <div class="about-tournament mt-3 mt-lg-5 py-4 container">
        <div class="d-flex flex-column flex-lg-row justify-content-between">
          <div class="py-lg-4 pr-lg-4">
            <div class="position-relative p-0 mb-2">
              <h2 class="section-title text-left">
                Rejoignez le tournoi WiGame Origins by MSE !
              </h2>
            </div>
            <div
              class="d-flex justify-content-between align-items-center flex-column flex-lg-row py-4"
            >
              <div class="mr-lg-5 mb-lg-0">
                <p class="text-justify text-about-tournament">
                  À l’occasion du lancement des activités de gaming de MSE sous
                  l’enseigne WiGame, participez au WiGame Origins,
                  <strong
                    >un tournoi inédit réunissant deux géants de l’e-sport :
                    Valorant et EAFC 26.</strong
                  ><br />
                  Les phases qualificatives se joueront en ligne du 12 au 18
                  novembre 2025, tandis que la grande finale se tiendra le 22
                  novembre 2025 au sein du nouveau centre WiGame au Club Wifaq à
                  Rabat, pour une expérience unique mêlant compétition, passion
                  et adrénaline.<br />
                  Ne manquez pas l’occasion de vous mesurer à d’autres gamers,
                  de relever le défi et de tenter de remporter les cash prizes
                  mis en jeu !
                </p>
              </div>
              <div class="" id="participate">
                <div class="wigame-card-container rounded-lg">
                  <img
                    :src="require('@/assets/FIGHT-FOR-GLORY.png')"
                    width="380px"
                    class="rounded-lg"
                    style="border: 2px solid rgba(255, 255, 255, 0.2)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-between align-items-center flex-column flex-md-row my-4 w-100"
        >
          <!-- participate valorant btn -->
          <!--<div
            class="rounded w-100 mr-4 btn-participate-card-container"
            style="background-color: var(--pink-variant)"
            @click="
              $emit('init-pop-up', {
                type: 'participate-valorant',
                title: 'Participer au tournoi Valorant',
                message:
                  'Confirmez-vous votre participation au tournoi Valorant ?',
                popUpDispatch:
                  'currentTournament/participateInValorantTournament',
                withOptions: false,
              })
            "
          >
            <div class="p-4">
              <img
                :src="require('@/assets/logos/valo-logo.png')"
                height="64px"
              />
            </div>
            <div>
              <div
                class="btn-participate-card px-5 text-uppercase py-2 font-weight-bold text-center w-100 d-flex justify-content-center align-items-center"
              >
                <h5 class="mr-4 mb-0">Participer</h5>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="36"
                  viewBox="0 0 19 36"
                  class="p-1"
                >
                  <path
                    d="M18,19h0L0,0H6.261L18,12.392,29.739,0H36L18,19Z"
                    transform="translate(0 36) rotate(-90)"
                    fill="#fff"
                  />
                </svg>
              </div>
            </div>
          </div> -->
          <div class="mb-3 mb-md-0 mr-md-4 w-100">
            <ParticipateCardGameValo
              @init-pop-up="initPopUp"
              @view-bracket="viewBracket"
              :image-src="require('@/assets/logos/valo-logo.png')"
              bg-color="var(--pink-variant)"
              label="Participer"
              :tournament-id="193"
            />
          </div>
          <div class="w-100">
            <ParticipateCardGame
              @init-pop-up="initPopUp"
              @view-bracket="viewBracket"
              :image-src="require('@/assets/logos/ea-fc-26.png')"
              bg-color="var(--blue-variant)"
              label="Participer"
              :tournament-id="192"
              :pop-up-options="{
                type: 'participate-ea',
                title: 'Participer au tournoi EA FC 26',
                message:
                  'Confirmez-vous votre participation au tournoi EA FC 26 ?',
                popUpDispatch: 'currentTournament/participateInEAFCTournament',
                withOptions: false,
              }"
            />
          </div>
        </div>
      </div>

      <div class="programme-container container mt-3 mt-lg-5 py-4">
        <h2 class="section-title text-left mb-4">Programme du tournoi</h2>
        <TimeLine />
      </div>
      <div class="prize-container container mt-3 mt-lg-5 py-4">
        <h2 class="section-title text-left mb-4">Cash prize</h2>
        <PrizesCards />
      </div>
      <div
        class="wigame-center-container container mt-3 mt-lg-5 py-4"
        id="wigame"
      >
        <h2 class="section-title text-left">
          WiGame, l’expérience gaming by MSE!
        </h2>
        <p class="text-justify text-about-tournament">
          Créé par <strong>Madaëf Sports & Events (MSE)</strong>, WiGame est un
          concept 100 % dédié à l’univers de l’e-sport et du loisir, offrant une
          <strong>expérience immersive</strong> dans un cadre
          <strong>moderne et innovant.</strong><br />
          Le premier centre, installé au
          <strong>Club Wifaq à Rabat</strong>, offre une
          <strong>expérience gaming haut de gamme</strong> avec des
          <strong
            >PC gamer pro ultra-performants équipés de processeurs Intel i7, de
            cartes graphiques RTX, d’écrans 180 Hz fluides et d’accessoires
            HyperX </strong
          >alliant confort et précision.<br />
          Cette ouverture marque le début d’un déploiement national visant à
          fédérer une communauté de passionnés à travers des tournois, sessions
          libres et expériences interactives.
        </p>
        <div class="row mx-0 my-4 w-100">
          <div class="col-12 col-md-6 mb-3">
            <div class="wigame-card-container rounded-lg h-100">
              <img
                :src="require('@/assets/wigame-1.png')"
                class="img-fluid w-100 rounded-lg"
                style="border: 2px solid rgba(255, 255, 255, 0.2)"
              />
            </div>
          </div>

          <div class="col-12 col-md-6 mb-3">
            <div class="wigame-card-container rounded-lg h-100">
              <iframe
                style="
                  border: 2px solid rgba(255, 255, 255, 0.2);
                  background-color: rgba(32, 32, 32, 0.3);
                "
                class="rounded-lg w-100 h-100"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3309.52753504847!2d-6.818751924487884!3d33.95327797319448!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda714b82be87705%3A0xd19fd7bccd7f66a2!2sClub%20Wifaq%20Tennis!5e0!3m2!1sfr!2sma!4v1760883808064!5m2!1sfr!2sma"
                width="100%"
                height="100%"
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          <div class="col-12 col-md-6 mb-3">
            <div
              class="wigame-card-container wigame-gradient rounded-lg h-100 w-100 d-flex justify-content-center align-items-center"
            >
              <img
                :src="require('@/assets/logos/wigame-logo.svg')"
                class="img-fluid p-4"
              />
            </div>
          </div>

          <div class="col-12 col-md-6 mb-3">
            <div class="wigame-card-container rounded-lg h-100">
              <img
                :src="require('@/assets/wigame-2.png')"
                class="img-fluid w-100 rounded-lg"
                style="border: 2px solid rgba(255, 255, 255, 0.2)"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="bracket-container container mt-3 mt-lg-5 py-4 w-100"
        id="bracket"
      >
        <div
          class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center mb-2"
        >
          <div class="position-relative p-0 m-0">
            <h2 class="section-title text-left">Brackets</h2>
          </div>
        </div>
        <div class="tab-header d-flex align-items-center">
          <div
            class="px-4 py-2 tab-header-item text-uppercase"
            :class="{ 'tab-active': currentTab == valorantTab }"
            @click="changeBracket(valorantTab)"
          >
            Valorant
          </div>
          <div
            class="px-4 py-2 tab-header-item text-uppercase"
            :class="{ 'tab-active': currentTab == eaFCTab }"
            @click="changeBracket(eaFCTab)"
          >
            EA FC 26
          </div>
        </div>
        <div class="bracket d-flex justify-content-center align-items-center">
          <LgameLoaderComp v-if="isLoading" />
          <BracketViewer v-else></BracketViewer>
        </div>
      </div>

      <div class="faq-container container mt-3 mt-lg-5 py-4 w-100">
        <h2 class="section-title text-left">FAQ</h2>
        <FaqList />
      </div>

      <!-- Discord help banner-->
      <!-- <div class="container p-lg-0 w-100">
        <DiscordBanner />
      </div> -->
      <!-- Mastercard Footer-->
      <div class="mt-5 w-100">
        <LPFooter />
      </div>
      <!-- lgame footer -->
      <!--<LgameFooter></LgameFooter>-->

      <!-- Lgame participate pop up-->
      <LgameParticipatePopUp
        :pop-up-type="popUpOptions.type"
        :title="popUpOptions.title"
        :pop-up-message-body="popUpOptions.message"
        :with-options="popUpOptions.withOptions"
        :options="popUpOptions.options"
        v-if="showPopUp"
        @modal-closed="abortAction"
        @acceptAction="acceptAction"
        @abortAction="abortAction"
      ></LgameParticipatePopUp>
    </div>
  </div>
</template>

<script>
import BracketViewer from "./BracketViewer.vue";
import ParticipateCard from "./ParticipateCard.vue";
import ParticipateCardGame from "./ParticipateCardGame.vue";
import ParticipateCardGameValo from "./ParticipateCardGameValo.vue";
// import LgameFooter from './LgameFooter.vue';
import LgameNavBar from "./NavBar.vue";
import LgameParticipatePopUp from "./LgameParticipatePopUp.vue";
import FaqList from "./FAQ/FaqList.vue";
import TimeLine from "./TimeLine.vue";
import PrizesCards from "./Prizes/PrizesCards.vue";
import LPFooter from "./LPFooter.vue";
import LgameLoaderComp from "./LgameLoaderComp.vue";
//import DiscordBanner from "./DiscordBanner.vue";

export default {
  name: "MainPage",
  components: {
    ParticipateCard,
    ParticipateCardGame,
    ParticipateCardGameValo,
    BracketViewer,
    LgameParticipatePopUp,
    LgameNavBar,
    //LgameFooter,
    FaqList,
    TimeLine,
    PrizesCards,
    LPFooter,
    LgameLoaderComp,
    // DiscordBanner,
  },
  data() {
    return {
      twitchPlayer: null,
      playerLoaded: false,

      showPopUp: false,
      popUpOptions: {
        type: "",
        title: "",
        message: "",
      },
      isMobile: false,
      currentTab: "VALORANT",
      valorantTab: "VALORANT",
      eaFCTab: "eaFcTab",
      isLoading: false,
    };
  },
  computed: {
    isLoaded: {
      get() {
        return !!this.currentTournament;
      },
      set(val) {
        return val;
      },
    },
    currentTournament: {
      get() {
        return this.$store.state.currentTournament.tournamentItem
          ? this.$store.state.currentTournament.tournamentItem
          : null;
      },
    },
  },
  methods: {
    changeBracket(tab) {
      this.currentTab = tab;
      this.isLoading = true;
      if (tab == this.valorantTab) {
        //set currentTournament to be valorant
        this.$store
          .dispatch("currentTournament/getTournament", 193)
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch("currentTournament/getTournament", 192)
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    initPlayer() {
      // eslint-disable-next-line
      this.twitchPlayer = new Twitch.Player(this.$refs["twitchPlayer"], {
        width: "100%",
        height: "100%",
        channel: "cihbankma",
      });
      this.twitchPlayer.setVolume(0.5);
      this.playerLoaded = true;
      // eslint-disable-next-line
      this.twitchPlayer.addEventListener(Twitch.Player.ONLINE, () => {
        /*this.$store.dispatch('currentTournament/setTwitchLive', {
                        isLive: true,
                    })*/
      });
      // eslint-disable-next-line
      this.twitchPlayer.addEventListener(Twitch.Player.ENDED, () => {
        /*this.$store.dispatch('currentTournament/setTwitchLive', {
                        isLive: false,
                    })*/
      });
    },
    acceptAction(payload) {
      this.showPopUp = false;

      if (payload && payload.hasCustomFields) {
        if (payload.teamId) {
          this.$store
            .dispatch("currentTournamentValo/setParticipantTeam", {
              teamId: payload.teamId,
              customFieldsValue: payload.customFieldsValues,
            })
            .then(() => {
              this.$store.dispatch(
                "currentTournamentValo/triggerLoading",
                false
              );
            });
        } else {
          this.$store
            .dispatch(this.popUpOptions.popUpDispatch, {
              customFieldsValue: payload.customFieldsValues,
            })
            .then(() => {
              this.$store.dispatch("currentTournament/triggerLoading", false);
            });
        }
      } else {
        if (payload && payload.teamId) {
          this.$store
            .dispatch("currentTournamentValo/setParticipantTeam", {
              teamId: payload.teamId,
            })
            .then(() => {
              this.$store.dispatch(
                "currentTournamentValo/triggerLoading",
                false
              );
            });
        } else {
          console.log("payload from pop up action ================= ");
          console.log(payload);
          console.log("payload from pop up action ================= ");
          if (this.popUpOptions.dispatchData) {
            this.$store
              .dispatch(
                this.popUpOptions.popUpDispatch,
                this.popUpOptions.dispatchData
              )
              .then(() => {
                this.$store.dispatch("currentTournament/triggerLoading", false);
              });
          } else {
            this.$store.dispatch(this.popUpOptions.popUpDispatch).then(() => {
              this.$store.dispatch("currentTournament/triggerLoading", false);
            });
          }
        }
      }
    },
    abortAction() {
      this.showPopUp = false;
      this.$store.dispatch("currentTournament/triggerLoading", false);
      this.$store.dispatch("currentTournamentValo/triggerLoading", false);
    },
    initPopUp(options) {
      this.popUpOptions = options;
      this.showPopUp = true;
    },
    viewBracket() {
      this.$refs.bracketTrigger.click();
    },
  },

  async created() {
    await this.$store.dispatch("currentUser/authCheck").then((response) => {
      if (response.success) {
        this.$store.dispatch("currentUser/setCurrentUser");
      }
    });
    this.$store.dispatch("currentTournament/getTournament", 192); // 144 cih tournament id
    this.$store.dispatch("currentTournamentValo/getTournament", 193); // 144 cih tournament id
  },
  async mounted() {
    console.log("token: ", process.env.VUE_APP_API_TOKEN);
    const resizeOps = () => {
      document.documentElement.style.setProperty(
        "--vh",
        window.innerHeight * 0.01 + "px"
      );
      this.isMobile = window.innerWidth <= 768 ? true : false;
    };

    resizeOps();
    window.addEventListener("resize", resizeOps);

    this.$refs["twitchScript"].onload = () => {
      this.initPlayer();
    };
  },
};
</script>

<style scoped>
.main-page-wrapper {
  color: white;
  background:
    linear-gradient(135deg, #000000 0%, #1a0033 25%, #00051a 50%, #000000 100%),
    radial-gradient(
      ellipse at 20% 30%,
      rgba(255, 0, 103, 0.15) 0%,
      transparent 50%
    ),
    radial-gradient(
      ellipse at 80% 70%,
      rgba(0, 119, 251, 0.15) 0%,
      transparent 50%
    );
}
.prizes-header-ar {
  z-index: 2;
}

.main-page-landing-area {
  min-height: calc(var(--vh, 1vh) * 100);
  background-image: url("@/assets/hero-banner.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
}

.how-to-container {
  z-index: 1;
}

.infos-section {
}
.section-title {
  color: white;
  font-family: "race_sportregular" !important;
  font-weight: 900 !important;
  text-transform: uppercase;
}
.section-title-sub {
  color: white;
  font-family: "urbanist" !important;
  background-color: #ed008c;
  font-weight: bold;
  width: 140px;
  line-height: 100%;
  padding-top: 2px;
  padding-bottom: 2px;
  text-transform: uppercase;
}

.arabic-title {
  font-family: "Tajawal", sans-serif !important;
  z-index: 5;
  font-weight: 600;
}
.how-to-text,
.how-to-text-ar {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  color: #707070;
  font-size: 14pt;
}
.how-to-text-ar {
  font-family: "Tajawal" !important;
}

.how-to {
  color: var(--main-color);
  font-family: "Tajawal";
  font-weight: 600;
  text-decoration: underline;
  font-size: 18pt;
}
.stream {
  height: 860px;
}
.bracket {
  height: 580px;
  background-color: #f5f5f5;
  overflow: hidden;
}

.prize-title {
  color: var(--main-color);
  text-transform: uppercase;
  font-family: "monument_extendedultrabold", sans-serif;
  font-size: 16pt;
  line-height: 100%;
}
.prize-card {
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.1));
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - 16px),
    calc(100% - 16px) 100%,
    0 100%
  );
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: white;
}

.krafton-copyright-footer-container {
  background-repeat: no-repeat;
  background-image: url("@/assets/footer.webp") !important;
  background-size: cover;
  background-position: bottom right;
}
.krafton-copyright-footer {
}
.contact-title {
  color: var(--main-color);
  font-family: "Roboto", sans-serif;
  font-weight: 700;
}
.contact-text {
  color: #707070;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
}
.contact-title-ar {
  color: var(--main-color);
  font-weight: 600;
  font-family: "Tajawal" !important;
}
.contact-text-ar {
  color: #707070;
  font-weight: 600;
  font-family: "Tajawal" !important;
}
.powered-by {
  color: white;
  font-size: 16pt;
  font-family: "Roboto Mono", sans-serif;
  font-weight: 300 !important;
}
.ezy-offer-wrapper {
  background-size: 100%;
  background-image:
    linear-gradient(to right, #00aeee4b 2px, transparent 2px),
    linear-gradient(to bottom, #00aeee4b 2px, transparent 2px);
  background-size: 32px 32px;
  position: relative;
}
.ezy-offer-wrapper:before,
.ezy-offer-wrapper:after {
  position: absolute;
  content: "";
  width: 100%;
  height: 60px;
  bottom: -10px;
  left: 0;
  background: #ffffff;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.4) 20%,
    rgba(255, 255, 255, 1) 100%
  );
}
.slogan-title {
  color: black;
  font-family: "montserrat", sans-serif;
  font-weight: bold;
}
.card-info-title-wrapper {
  background-image: url("@/assets/card-title-bg.png") !important;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 10px;
  padding-bottom: 10px;
}
.card-info-title {
  font-family: "montserrat", sans-serif;
  font-weight: 500;
  font-size: 16pt;
}
.card-description {
  color: black;
}

.timeline-card {
  background-size: 100%;
  background-image:
    linear-gradient(to right, #ffffff27 2px, transparent 2px),
    linear-gradient(to bottom, #ffffff27 2px, transparent 2px);
  background-size: 24px 24px;
}
.bg-card-yellow {
  background-color: #ffd633;
}
.bg-card-blue {
  background-color: #25abe3;
}
.bg-card-pink {
  background-color: #ed008c;
}
.timeline-card-title {
  font-family: "montserrat", sans-serif;
  font-weight: bold;
}
.text-about-tournament {
  color: white;
  font-family: "montserrat", sans-serif;
  font-weight: 500;
  font-size: 16pt;
}
.text-sub-desc {
  font-family: "montserrat", sans-serif;
  font-weight: 400;
  font-size: 13pt;
}
.logo-efootball-container {
  position: absolute;
  height: 130px;
  aspect-ratio: 1;
  bottom: 10px;
  right: 10px;
}
.discover-more {
  background-image: url("@/assets/bg-yellow.png") !important;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 240px;
  justify-self: end;
}
.discover-more a {
  outline: none;
  font-family: "montserrat", sans-serif !important;
  font-weight: 600;
  font-size: 13pt;
}

.btn-participate-card {
  background: #fff;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.35) 35%,
    rgba(255, 255, 255, 0.35) 70%,
    rgba(255, 255, 255, 0) 100%
  );
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-family: "race_sportregular" !important;
}
.btn-participate-card > h5 {
  font-family: "race_sportregular" !important;
}
.btn-participate-card-container:hover {
  cursor: pointer;
  transform: scale(1.01);
  transition: transform 0.3s ease-in-out;
}
.wigame-gradient {
  border: 2px solid rgba(255, 255, 255, 0.2);
}
.tournament-title {
  font-family: "race_sportregular" !important;
}
.tab-header-item {
  border: 1px solid var(--pink-variant);
  font-weight: 900;
  background-color: transparent;
}
.tab-header-item:hover {
  cursor: pointer;
}
.tab-active {
  background-color: var(--pink-variant);
}

@media screen and (max-width: 800px) {
}

@media screen and (max-width: 768px) {
  .br {
    visibility: hidden;
  }
  .main-page-landing-area {
    background-image: url("@/assets/banner-mb.png") !important;
    background-position: center center !important;
    background-size: cover !important;
  }
  .main-page-landing-area:before {
    width: 0;
    /*background-image:url('@/assets/hero-mobile-bg.png') !important;*/
  }
  .main-page-landing-area:before {
  }
  .tournament-logo img {
    height: 120px;
  }

  .partners-container img {
    height: 32px;
  }

  .section-title {
    font-size: 18pt;
  }
  .how-to-content {
    background-position: bottom right;
    background-repeat: no-repeat;
    background-size: 80%;
  }
  .stream {
    width: 100% !important;
    height: 360px;
  }
  .bracket {
    height: 70vh;
  }
  .logo-efootball-container {
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    height: 80px;
  }
  .logo-efootball-container img {
    height: 80px;
  }
  .wigame-card-container img {
    height: 280px;
  }
}
</style>
